import { api } from '@config/api';
import type { LoginInput } from '../components/LoginForm.schema';
import type { User } from '../types/User';

export const authService = {
  me: () => api.get<User>('/me').then((r) => r.data),
  login: (input: LoginInput) => api.post<User>('/auth/login', input).then((r) => r.data),
  logout: () => api.post('/auth/logout').then(() => undefined),
};
